import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/charge/pay/page', Object.assign({}, options, { params }));

export const getOffLinePaySum = (params, options) =>
  request.get('/api/v4ward/charge/pay/offLinePaySum', Object.assign({}, options, { params }));
